'use client';
import { useState, useEffect, useContext } from 'react';
import './MyPetProfiles.scss';
import 'react-phone-input-2/lib/style.css';
import { useNavigate, useParams } from 'react-router-dom';
import { PetskedTitle } from '@/components/Heading/PetskedTitle';
import { BackNav } from '@/components/BackNavigation/BackNavigation';
import { useGetPetsList } from '../api/getPetsList';
import { useAuth } from '@/lib/auth';
import { Pet } from '../types';
import { PetProfileCard } from '../components/PetProfileCard';
import { AddNewPetCard } from '../components/AddNewPetCard';
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import { Modal } from 'react-bootstrap';
import { PetProfileForm } from '../components/PetProfileForm';
import { Loader } from '@/components/Loader/Loader';
import { UserContext } from '@/components/Layout';
import { useTranslation } from 'react-i18next';
export default function MyPetProfile() {
  const userContext = useContext(UserContext);
  const navigate = useNavigate();
  const useGetEventsMutation = useGetPetsList();
  const { user } = useAuth();
  const { t, i18n } = useTranslation();
  const [myPets, setMyPets] = useState<Pet[]>();
  const [showAddPetModal, setShowAddPetModal] = useState<boolean>(false);
  useEffect(() => {
    getMyPets(false);
  }, []);

  const getMyPets = async (isPast: boolean) => {
    const res = await useGetEventsMutation.mutateAsync({
      businessId: user?.businessId,
      page: 0,
      perPage: 20,
      isPast: isPast,
    });
    setMyPets(res.list);
  };
  const onSelectMyPet = (pet: Pet) => {
    navigate(`/pet-profile/${pet.id}`);
  };
  const onAddNewPet = () => {
    setShowAddPetModal(true);
  };
  const onAddPetSucess = () => {
    getMyPets(false);
    setShowAddPetModal(false);
  };
  const showBackNav = !userContext?.isLandscape && showAddPetModal;
  return (
    <section className="petsked-container-bg my-pet-profiles">
      {showBackNav ? (
        <BackNav
          onClick={() => {
            setShowAddPetModal(false);
          }}
        />
      ) : (
        <>
          <div className="top-section">
            <PetskedTitle
              title={t("Pet")}
              highlightTitle={t("Profiles")}
              size="lg"
              alignText="left"
              description=""
            />
            <div className={`my-pets ${useGetEventsMutation.isLoading ? 'loading' : ''}`}>
              {useGetEventsMutation.isLoading ? (
                <Loader text="" />
              ) : (
                <>
                  <AddNewPetCard onClick={onAddNewPet} />
                  {myPets &&
                    myPets.length > 0 &&
                    !useGetEventsMutation.isLoading &&
                    myPets.map((pet, index) => {
                      return (
                        <PetProfileCard
                          data={pet}
                          key={`my-pet-${index}`}
                          onSelect={onSelectMyPet}
                          isSelected={false}
                          hideSelect={true}
                        />
                      );
                    })}
                </>
              )}
            </div>
          </div>
          <div className="notes">
            <p>
              <span>{t('Note:')}</span> {t('You can include all your pets here by providing basic information initially, but be sure to include and attach essential pet-related details and documents within each profile.')}
            </p>
          </div>
        </>
      )}
      {showAddPetModal && (
        <>
          {userContext?.isLandscape ? (
            <>
              <Modal
                className="petsked-modal-dialog petsked-add-pet-modal"
                show={showAddPetModal ? true : false}
                onHide={() => setShowAddPetModal(false)}
              >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                  <PetProfileForm onSuccess={onAddPetSucess} isEditMode={false} defaultPetType={user?.defaultPetType} />
                </Modal.Body>
              </Modal>
            </>
          ) : (
            <>
              <PetProfileForm onSuccess={onAddPetSucess} isEditMode={false} defaultPetType={user?.defaultPetType}/>
            </>
          )}
        </>
      )}
    </section>
  );
}
